module.exports = __webpack_public_path__ + "static/media/empathy_intro_ie.fb3f997d.png";